import React, {Component} from 'react';
import i18next from 'i18next';
import MenuItem from './MenuItem';
import * as rights from './../model/rights';
import ParentMenuItem from './ParentMenuItem';
import Logo from './header/Logo';

class Menu extends Component {
  render() {
    const parentStyle = {
      zIndex: 9996,
      position: 'fixed',
    };
    const style = {
      backgroundColor: '#292929',
      fontColor: '#CCCCCC',
    };
    return (
      <aside className="page-sidebar-wrapper" style={parentStyle}>
        <div className="page-sidebar navbar-collapse collapse" style={style}>
          <ul
            className="page-sidebar-menu"
            data-keep-expanded="true"
            data-auto-scroll="true"
            data-slide-speed="200"
          >
            <Logo/>

            <MenuItem
              route="/"
              isIndex={true}
              icon="icon-bar-chart"
              title={i18next.t('dashboard.title')}
            />

            {rights.currentUserHasRight(rights.SITE_READ_PRIVILEGE) ? (
              <MenuItem
                route="/sites"
                icon="icon-home"
                title={i18next.t('sites.name', {count: 2})}
              />
            ) : null}

            {rights.currentUserHasRight(rights.USER_READ_PRIVILEGE) ? (
              <MenuItem
                route="/users"
                icon="icon-users"
                title={i18next.t('users.name', {count: 2})}
              />
            ) : null}

            <ParentMenuItem title="RESERVATIONS"></ParentMenuItem>

            {rights.currentUserHasRight(rights.RESERVATION_READ_PRIVILEGE) ? (
              <MenuItem
                route="/bookings"
                icon="icon-calendar"
                title={i18next.t('checkins.name', {count: 2})}
              />
            ) : null}

            {rights.currentUserHasRight(rights.MOBILE_USER_READ_PRIVILEGE) ? (
              <MenuItem
                route="/mobile_users"
                icon="icon-screen-smartphone"
                title={i18next.t('mobile_users.name', {count: 2})}
              />
            ) : null}

            {rights.currentUserHasRight(rights.SPECIAL_AREA_READ_PRIVILEGE) ? (
              <MenuItem
                route="/specialareas"
                icon="icon-lock"
                title={i18next.t('specialareas.name', {count: 2})}
              />
            ) : null}

            <ParentMenuItem title="MONITORING"></ParentMenuItem>

            {rights.currentUserHasRight(rights.SITE_READ_PRIVILEGE) ? (
              <MenuItem
                route="/rooms"
                icon="icon-grid"
                title={i18next.t('rooms.name', {count: 2})}
              />
            ) : null}

            {rights.currentUserHasRight(rights.WIRELESS_CONFIG_READ_PRIVILEGE) ? (
              <MenuItem
                route="/terminals"
                icon="icon-screen-tablet"
                title={i18next.t('terminals.menu')}
              />
            ) : null}

            {rights.currentUserHasRight(rights.LOG_READ_PRIVILEGE) ? (
              <MenuItem
                route="/transaction_logs"
                icon="icon-list"
                title={i18next.t('transaction_logs.name', {count: 2})}
              />
            ) : null}

            {rights.currentUserHasRight(rights.LOG_READ_PRIVILEGE) ? (
              <MenuItem
                route="/logs_key_creation"
                icon="icon-list"
                title={i18next.t('logs.key_creation.menu')}
              />
            ) : null}

            <ParentMenuItem title="ADVANCED"></ParentMenuItem>

            {rights.currentUserHasRight(rights.WIRELESS_CONFIG_READ_PRIVILEGE) ? (
              <MenuItem
                route="/management"
                icon="icon-settings"
                title={i18next.t('site_management.menu')}
              />
            ) : null}

            {rights.currentUserHasRight(rights.DEVELOPER_READ_PRIVILEGE) ? (
              <MenuItem
                route="/developers"
                icon="icon-screen-desktop"
                title={i18next.t('developers.name', {count: 2})}
              />
            ) : null}

            <MenuItem
              route="/info"
              icon="icon-info"
              title={i18next.t('info.name')}
            />
          </ul>
        </div>
      </aside>
    );
  }
}

Menu.propTypes = {};
Menu.defaultProps = {};

export default Menu;
